import React, { useEffect, useCallback, useState} from 'react';
import {setSelectedPalette} from 'actions/index.js';
import {connect} from 'react-redux';
import PaletteDetails from './PaletteDetails.js';
import {PALETTE_COLORS} from 'constants/palette-colors.js';


const PaletteEffectComponent = ({effect, selectedPalette, setSelectedPalette}) => { 
    const [palettes, setPalettes] = useState([... effect.palettes]);

    const newPalette = useCallback(() => {
        effect.newPalette();
        setPalettes([... effect.palettes]);
    }, [setPalettes]);

    const onChoose = useCallback((p) => {
        if (p === selectedPalette) {
            p = undefined;
        }
        effect.switchToPalette(p, selectedPalette, undefined, true);
    }, [effect, selectedPalette]);

    return (
        <div className="palettes-effect">
          <div className="palettes-container">
            {palettes.map(
                p =>
                    <PaletteOption
                      onChoose={onChoose}
                      selectedPalette={selectedPalette}
                      palette={p}/>)}
            <div
              onClick={newPalette}
              className="new-palette-btn">
              +
            </div>
          </div>
        </div>);
    /*

        {selectedPalette !== undefined ?
         <PaletteDetails palette={selectedPalette} effect={effect}/> : ''}
         */
};

const PaletteOption = ({selectedPalette, palette, onChoose}) => {
    const className = selectedPalette === palette ?
          "selected palette-option" : "palette-option";

    let style = {
        backgroundColor: PALETTE_COLORS[palette]
    };
    return (
        <div
          style={style}
          onClick={() => onChoose(palette)} className={className}>
          {palette + 1}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let palette = state.effects.sequencedPalettes[props.effect.track.id];
    let selectedPalette = state.effects.selectedPalettes[props.effect.track.id];
    return {
        selectedPalette: selectedPalette !== undefined ? selectedPalette : palette
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPalette: (trackId, palette) => dispatch(setSelectedPalette(trackId, palette))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaletteEffectComponent);
